import { configureStore } from "@reduxjs/toolkit";
import reducers from "./reducers";
import thunkMiddleware from "redux-thunk";

// If it's the development build, then wire the Redux store to the Redux dev tools plugin
export const store = configureStore({
  reducer: reducers,
  middleware: [thunkMiddleware],
  devTools: true,
});
export default store;
